window.getCardType = function(number) {
    var cards = [
        {
            name: 'visa',
            pattern: '^4[0-9]{12}(?:[0-9]{3})?$',
            cvv: 3
        },
        {
            name: 'mastercard',
            pattern: '^(5[1-5][0-9]{14}|2221[0-9]{12}|222[2-9][0-9]{12}|22[3-9][0-9]{13}|2[3-6][0-9]{14}|27[01][0-9]{13}|2720[0-9]{12})$',
            cvv: 3
        },
        {
            name: 'discover',
            pattern: '^6(?:011|5[0-9]{2}|4[4-9][0-9]{1}|(22(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[01][0-9]|92[0-5]$)[0-9]{10}$))[0-9]{12}$',
            cvv: 3
        },
        {
            name: 'amex',
            pattern: '^3[47][0-9]{13}$',
            cvv: 4
        }
    ];

    number = number.replace(/\D/g, '');

    for(var i = 0; i < cards.length; i++) {
        var regex = new RegExp(cards[i].pattern);
        if(regex.test(number)) {
            return {
                name: cards[i].name,
                cvv: cards[i].cvv
            };
        }
    }
    return false;
}

window.renameKeys = function(obj, newKeys) {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = newKeys[key] || key;
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
}

window.stripFromKeys = function(obj, str) {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = key.replace(str, '');
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
}

window.prependToKeys = function(obj, str) {
    const keyValues = Object.keys(obj).map(key => {
        const newKey = str + key;
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
}

window.premierDate = function() {
  var today = new Date().toLocaleString('en-US', {
    timeZone: 'America/Chicago'
  });

  return new Date(today);
};
